import React from "react";
import PropTypes from "prop-types";
import DateTimeField from "./DateTimeField";
import { useI18n } from "Hooks";

const DueDateField = ({
  dateRange,
  isEditMode,
  isDisabled,
  disabledTooltip,
  showError,
  testId,
  onValidationError,
}) => {
  const { t } = useI18n(["classRoom", "calendar"]);

  return (
    <DateTimeField
      fieldName="dueDate"
      label={t("classRoom:due_date")}
      tooltipText={t("calendar:shows_when_assignment_due")}
      dateRange={dateRange}
      isEditMode={isEditMode}
      isDisabled={isDisabled}
      disabledTooltip={disabledTooltip}
      showError={showError}
      testId={testId}
      onValidationError={onValidationError}
    />
  );
};

DueDateField.propTypes = {
  /** Date range constraints */
  dateRange: PropTypes.object,
  /** Whether field is in edit mode */
  isEditMode: PropTypes.bool,
  /** Whether field is disabled */
  isDisabled: PropTypes.bool,
  /** Tooltip to show when disabled */
  disabledTooltip: PropTypes.node,
  /** Whether to show error styling */
  showError: PropTypes.bool,
  /** Test ID for testing */
  testId: PropTypes.string,
  /** Callback when validation error occurs */
  onValidationError: PropTypes.func,
};

DueDateField.defaultProps = {
  dateRange: null,
  isEditMode: false,
  isDisabled: false,
  disabledTooltip: null,
  showError: false,
  testId: "due-date",
  onValidationError: null,
};

export default DueDateField;
